var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var toursShortIdStorage = {};

        var I18nMessages = function () {
            function I18nMessages() {
                _classCallCheck(this, I18nMessages);
            }

            _createClass(I18nMessages, null, [{
                key: "template",

                /**
                 * @param {string} message
                 * @param {{}} params
                 * @return {string}
                 */
                value: function template(message, params) {
                    var isCustomTemplate = message === 'з{city, select, Львова{і} other{}} {city}';

                    for (var key in params) {
                        if (params.hasOwnProperty(key)) {
                            message = message.split('{' + key + '}').join(params[key]);
                        }
                    }

                    // есть шаблон: з{city, select, Львова{і} other{}} {city}
                    // не очень хочется это в JS реализовывать, поэтому просто уберем оставшиеся выражения
                    if (isCustomTemplate) {
                        return message.replace(/{.*}/, '');
                    }

                    return message;
                }
                /**
                 * @param {number} number
                 * @param {[string, string, string]} pluralMessage
                 */

            }, {
                key: "plural",
                value: function plural(number, pluralMessage) {
                    var _window$utils;

                    return (_window$utils = window.utils).getnoun.apply(_window$utils, [number].concat(_toConsumableArray(pluralMessage)));
                }
            }]);

            return I18nMessages;
        }();

        window.selectUtils = {
            isContainValue: function isContainValue($select, value) {
                return $select.find('option[value="' + value + '"]').length !== 0;
            },
            setSelectedAttribute: function setSelectedAttribute($select) {
                var selectedValue = $select.val();
                var $optionWithSelectedAttr = $select.find('option[selected]');
                if ($optionWithSelectedAttr.length && $optionWithSelectedAttr.val() !== selectedValue) {
                    $optionWithSelectedAttr.removeAttr('selected');
                    $select.find('option[value="' + selectedValue + '"]').attr('selected', true);
                }
            }
        };
        window.utils = {
            i18n: I18nMessages,
            isLocalStorageSupported: function () {
                try {
                    if ('localStorage' in window === false) {
                        return false;
                    }
                    if (_typeof(window.localStorage) !== 'object') {
                        return false;
                    }

                    var testKey = 'test',
                        storage = window.localStorage;
                    storage.setItem(testKey, '1');
                    storage.removeItem(testKey);
                    return true;
                } catch (error) {
                    return false;
                }
            }(),
            cookies: {
                /**
                 * Возвращает cookie с именем name, если есть, если нет, то undefined
                 * @param {string} name
                 * @return {any|undefined}
                 */
                get: function get(name) {
                    var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
                    return matches ? decodeURIComponent(matches[1]) : undefined;
                },
                /**
                 * options.expires in seconds
                 *
                 * @param {string} name
                 * @param {*} value
                 * @param {{
                 *  expires: number
                 * }} options
                 */
                set: function set(name, value, options) {
                    options = options || {};

                    var expires = options.expires;
                    if (typeof expires === 'number' && expires) {
                        var d = new Date();
                        d.setTime(d.getTime() + expires * 1000);
                        expires = options.expires = d;
                    }
                    if (expires && expires.toUTCString) {
                        options.expires = expires.toUTCString();
                    }

                    value = encodeURIComponent(value);

                    var updatedCookie = name + "=" + value;

                    for (var propName in options) {
                        updatedCookie += "; " + propName;
                        var propValue = options[propName];
                        if (propValue !== true) {
                            updatedCookie += "=" + propValue;
                        }
                    }

                    document.cookie = updatedCookie;
                }
            },
            /**
             * @param {string} realId
             * @param {string|object} selector - куда вставить результат (object == jquery object)
             * @param {!Function} callback
             */
            getShortTourId: function getShortTourId(realId, selector, callback) {
                var $elems = $(selector);
                if ($elems.length) {
                    if (toursShortIdStorage.hasOwnProperty(realId)) {
                        $elems.html('#' + toursShortIdStorage[realId]);
                        if (typeof callback === 'function') {
                            callback('#' + shortId);
                        }
                    } else {
                        $elems.html('<img src="/img/load.gif">');
                        var vUid = app.v_uid || '';
                        $.post('/get-short-id', { realId: realId, v_uid: vUid }, function (data) {
                            var shortId = realId;
                            if (data && data.success && data.shortId) {
                                shortId = data.shortId;
                            }

                            toursShortIdStorage[realId] = shortId;

                            $elems.html('#' + shortId);
                            if (typeof callback === 'function') {
                                callback(shortId);
                            }
                        }, 'json');
                    }
                } else {
                    if (typeof callback === 'function') {
                        callback(null);
                    } else {
                        return null;
                    }
                }
            },
            /**
             * @param {HTMLElement} button
             */
            showHiddenPhone: function showHiddenPhone(button) {
                var type = button.getAttribute('data-type');
                var cityId = button.getAttribute('data-city');
                var city = window.CityItem.findById(cityId);
                $(button).replaceWith(type === 'alt' ? city.altPhone.linkHtml : city.currentPhone.linkHtml);
            },

            /**
             * @param {Function} callback
             * @param {number} wait
             * @return {Function}
             */
            debounce: function debounce(callback, wait) {
                var timeout = void 0;
                return function () {
                    var context = this,
                        args = arguments;
                    clearTimeout(timeout);
                    timeout = setTimeout(function () {
                        timeout = null;
                        callback.apply(context, args);
                    }, wait);
                    return true;
                };
            },
            /**
             * @param {Function} callback
             * @param {number} wait
             * @return {Function}
             */
            throttle: function throttle(callback, wait) {
                var lastCallTime = Date.now();
                return function () {
                    if (lastCallTime + wait - Date.now() < 0) {
                        callback.apply(this, arguments);
                        lastCallTime = Date.now();
                    }
                    return true;
                };
            },
            isObject: function isObject(data) {
                return (typeof data === "undefined" ? "undefined" : _typeof(data)) === 'object' && data !== null;
            },
            cl: function cl(text) {
                console.log(text);
            },
            jp: function jp(d) {
                return JSON.parse(d);
            },
            js: function js(d) {
                return JSON.stringify(d);
            },
            ksort: function ksort(w, sort_function) {
                var sArr = [],
                    tArr = [],
                    n = 0;

                for (i in w) {
                    tArr[n++] = i;
                }

                if (sort_function && typeof sort_function == "function") {
                    tArr = tArr.sort(sort_function);
                } else {
                    tArr = tArr.sort();
                }
                for (var i = 0, n = tArr.length; i < n; i++) {
                    sArr[tArr[i]] = w[tArr[i]];
                }
                return sArr;
            },
            nf: function nf(val) {
                return ('' + val).replace(/\B(?=(\d{3})+(?!\d))/g, "&nbsp;");
            },
            nfm: function nfm(val, min) {
                if (!min) {
                    min = 10000;
                }
                return Number(val) >= min ? window.utils.nf(val) : val;
            },
            getnoun: function getnoun(number, one, two, five, glue) {
                number = Math.abs(number);
                number = number % 100;
                glue = glue ? '' + number + ' ' : '';
                if (number >= 5 && number <= 20) {
                    return glue + five;
                }
                number = number % 10;
                if (number === 1) {
                    return glue + one;
                }
                if (number >= 2 && number <= 4) {
                    return glue + two;
                }
                return glue + five;
            },
            /**
             * @param obj
             * @return {number}
             */
            count: function count(obj) {
                if (obj.hasOwnProperty('length')) {
                    return obj.length;
                }
                var res = 0;
                var key = void 0;
                for (key in obj) {
                    if (obj.hasOwnProperty(key)) res++;
                }
                return res;
            },
            equalHeight: function equalHeight($elements, useActual) {
                var maxHeight = 0;
                $elements.each(function () {
                    var hh = useActual ? $(this).actual('outerHeight') : $(this).outerHeight();
                    if (hh > maxHeight) maxHeight = hh;
                });
                $elements.height(maxHeight);
            },
            isElementInPopup: function isElementInPopup($el) {
                return !!$el.closest(window.app.isMobile ? '.m-popup' : '.modal').length;
            },
            isElementInViewport: function isElementInViewport(el) {
                // special bonus for those using jQuery
                if (typeof window.jQuery === "function" && el instanceof window.jQuery) {
                    el = el[0];
                }
                var rect = el.getBoundingClientRect();

                return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
                rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
                ;
            },
            isAnyPartOfElementInViewport: function isAnyPartOfElementInViewport(el) {
                // special bonus for those using jQuery
                if (typeof window.jQuery === "function" && el instanceof window.jQuery) {
                    el = el[0];
                }
                var rect = el.getBoundingClientRect();
                // DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
                var windowHeight = window.innerHeight || document.documentElement.clientHeight;
                var windowWidth = window.innerWidth || document.documentElement.clientWidth;

                // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
                var vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
                var horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;

                return vertInView && horInView;
            },

            scrollToElement: function scrollToElement($el, deltaTop) {
                if ($el.length) {
                    var inPopup = window.utils.isElementInPopup($el);
                    var scrollTop = void 0;
                    var $scrollParent = void 0;
                    if (!inPopup) {
                        $scrollParent = $("html, body");
                        scrollTop = $el.offset().top;
                    } else {
                        $scrollParent = $el.scrollParent();
                        scrollTop = $scrollParent.scrollTop() - $scrollParent.offset().top + $el.offset().top;
                    }
                    $scrollParent.animate({ scrollTop: scrollTop - (deltaTop ? deltaTop : 0) }, 500);
                }
            },
            /**
             * @param {jQuery} $parent
             * @param {boolean} img
             * @param {boolean} background
             */
            loadImages: function loadImages($parent) {
                var img = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                var background = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                if (img) {
                    $parent.find('img.lazy-image').each(function () {
                        var $image = $(this);
                        $image.prop('src', $image.data('src'));
                        $image.removeClass('lazy-image');
                        $image.removeAttr('data-src');
                    });
                }
                if (background) {
                    $parent.find('.lazy-image-bg').each(function () {
                        var $item = $(this);
                        $item.css('backgroundImage', 'url(' + $item.data('src') + ')');
                        $item.removeClass('lazy-image-bg');
                        $item.removeAttr('data-src');
                    });
                }
            },
            /**
             * @param {string} previewSrc
             * @param {string} size - sm|sm4x3|md|big
             * @return {string}
             */
            getHotelPhoto: function getHotelPhoto(previewSrc) {
                var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'sm4x3';

                return app.staticDomain + "/img/h/" + size + "/" + previewSrc;
            }
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /*sockets realTime*/
        window.callbacks = {};
        window.c_act_user_id = '';
        window.rtLoginParams = '';
        window.funcs = {};

        function randId() {
            return new Date().getTime() + Math.random();
        }

        //вызовы, запрошенные до события login
        window.rt = {
            connected: false,
            delayed_actions: [],
            afterLogin: {},
            afterClose: {},
            bind: function bind(route, callback) {
                if (route in funcs) {
                    funcs[route].push(callback);
                } else {
                    funcs[route] = [callback];
                }
                return rt;
            },
            trigger: function trigger(route, data) {
                if (route in funcs) {
                    for (var i = 0; i < funcs[route].length; i++) {
                        if (typeof funcs[route][i] === 'function') {
                            funcs[route][i](data);
                        }
                    }
                }
            },
            isOnline: function isOnline() {
                return rt.sock && rt.sock.readyState == 1;
            },
            setLoginParams: function setLoginParams(params) {
                rtLoginParams = params;
            }
        };

        window.rtInit = function () {
            var sockUrl = app.sock.main;
            if (location.hash === '#local' || document.cookie.indexOf('local_ws') !== -1 || document.cookie.indexOf('ws_local') !== -1) {
                sockUrl = app.sock.local;
            }
            rt.sock = new SockJS(sockUrl);
            rt.isLogin = false;
            rt.timer = false;
            rt.go = function (route, data, callback) {
                if (!rt.connected) {
                    rt.delayed_actions.push({
                        route: route,
                        data: data,
                        callback: callback
                    });
                } else {
                    var res = route.split('.');
                    if (callback) {
                        var callbackId = 'callback_' + randId();
                        if ((typeof data === "undefined" ? "undefined" : _typeof(data)) === 'object') {
                            data.clientCallbackId = callbackId;
                        }
                        if (!callbacks[route]) {
                            callbacks[route] = {};
                        }
                        callbacks[route][callbackId] = callback;
                        callbacks[route].lastCallback = callback;
                    }
                    rt.sock.send(window.utils.js({
                        c: res[0],
                        a: res[1],
                        d: data
                    }));
                }
                return rt;
            };

            rt.sock.onopen = function () {
                rt.connected = true;
                // var now = new Date();
                // console.log('open : ' + now.toString());
                rt.go('app.login', {
                    id: app.id,
                    key: app.key,
                    nid: app.nid,
                    nkey: app.nkey,
                    ukey: app.ukey,
                    bkey: app.bkey,
                    opToken: app.opToken,
                    site: 1,
                    cur: app.currency,
                    loginParams: rtLoginParams,
                    isMobile: app.isMobile,
                    location: window.location.href
                }, function (data) {
                    // var now = new Date();
                    // console.log('login : ' + now.toString());
                    if (data.success) {
                        rt.isLogin = true;
                    }
                    var i;
                    for (i in rt.afterLogin) {
                        rt.afterLogin[i](data);
                    }
                    if (rt.delayed_actions.length) {
                        for (i = 0; i < rt.delayed_actions.length; i++) {
                            rt.go(rt.delayed_actions[i]['route'], rt.delayed_actions[i]['data'], rt.delayed_actions[i]['callback']);
                        }
                        rt.delayed_actions = [];
                    }
                });
            };

            rt.sock.onmessage = function (e) {
                var data = window.utils.jp(e.data);
                if (callbacks[data.r]) {
                    if (data.d && data.d.clientCallbackId) {
                        if (typeof callbacks[data.r][data.d.clientCallbackId] === 'function') {
                            callbacks[data.r][data.d.clientCallbackId](data.d);
                        }
                        delete callbacks[data.r][data.d.clientCallbackId];
                    } else {
                        if (typeof callbacks[data.r].lastCallback === 'function') {
                            callbacks[data.r].lastCallback(data.d);
                        }
                        delete callbacks[data.r];
                    }
                }
                rt.trigger(data.r, data.d ? data.d : {});
            };

            rt.sock.onclose = function () {
                rt.connected = false;
                for (var i in rt.afterClose) {
                    rt.afterClose[i]();
                }
                clearTimeout(rt.timer);
                rt.timer = setTimeout(rtInit, 3000);
            };

            rt.sock.onheartbeat = function () {
                //console.log('heartbeat');
            };
        };
        $(function () {
            rtInit();
        });

        rt.afterLogin['todo.join'] = function (data) {
            if (data.isManager) {
                rt.go('chans.join', { id: 'notify' });
            }
        };
        rt.bind('notify.mess', function (data) {
            if (data) {
                window.utils.cl(data);
            }
        });
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var statLog = [];
        var statEvents = [];
        var ymEvents = [];

        var FORM_CALLBACK = 1; // Обрытный звонок
        var FORM_SUBSCRIBTION = 2; // Подписка на email
        var FORM_TOURS_REQ = 3; // Обратка
        var FORM_SEARCH_FEEDBACK = 4; // "Ничего не смогли найти?" на странице поиска

        /**
         * Возвращает массив css классов маркеров для GTM
         * 0 - successful
         * 1 - failed
         * @param {number} type
         * @returns {string[]}
         */
        function formResultClasses(type) {
            switch (Number(type)) {
                case FORM_CALLBACK:
                    return ['successful-callback', ''];
                case FORM_SUBSCRIBTION:
                    return ['successful-email-subscription', ''];
                case FORM_TOURS_REQ:
                    return ['successful-tours-request', ''];
                case FORM_SEARCH_FEEDBACK:
                    return ['successful-customer-feedback', 'failed-customer-feedback'];
                default:
                    console.error('No options specified for form %s', type);
            }

            return ['', ''];
        }

        /**
         * Разметка результатов выполнения форм на сайте для GTM
         */
        var formConversion = {
            /**
             * Разметить состояние заказа обратного звонка
             * @param {HTMLElement} element
             * @param {boolean} success
             */
            markCallback: function markCallback(element) {
                var success = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                this.mark(FORM_CALLBACK, element, success);
            },

            /**
             * Разметить состояние подписки на email
             * @param {HTMLElement} element
             * @param {boolean} success
             */
            markSubscription: function markSubscription(element) {
                var success = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                this.mark(FORM_SUBSCRIBTION, element, success);
            },

            /**
             * Разметить состояние заказа обратки
             * @param {HTMLElement} element
             * @param {boolean} success
             */
            markToursReq: function markToursReq(element) {
                var success = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                this.mark(FORM_TOURS_REQ, element, success);
            },

            /**
             * Разметить состояние формы "Ничего не смогли найти" на странице поиска
             * @param {HTMLElement} element
             * @param {boolean} success
             */
            markSearchFeedback: function markSearchFeedback(element) {
                var success = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                this.mark(FORM_SEARCH_FEEDBACK, element, success);
            },

            /**
             * Удалить маркеры перед повторной отправкой формы/перед показом формы
             * Например:
             *  Ошибка валидации: Маркер - fail
             *  Исправил: Маркер - success. Fail нужно удалить
             *  @param {HTMLElement} element
             */
            unmark: function unmark(element) {
                var type = Number(element.dataset.analytic);
                if (type) {
                    var _element$classList;

                    (_element$classList = element.classList).remove.apply(_element$classList, _toConsumableArray(formResultClasses(type)));
                }
            },


            /**
             * @private
             * @param {number} type
             * @param {HTMLElement} element
             * @param {boolean} success
             */
            mark: function mark(type, element) {
                var success = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

                var i = success ? 0 : 1;
                element.classList.add(formResultClasses(type)[i]);
                element.dataset.analytic = type; // Для снятия маркировки
            }
        };

        function isDefined(variable) {
            return typeof variable !== 'undefined';
        }

        window.tracking = {
            sendAnalyticsEvent: function sendAnalyticsEvent(eventName) {
                if (window.roistat) {
                    console.log('sendAnalyticsEvent: ' + eventName);
                    window.roistat.event.send(eventName);
                } else {
                    console.log('sendAnalyticsEvent: roistat not exist');
                }
            },
            setGAEvent: function setGAEvent(eventCategory, eventAction) {
                console.log('setGAEvent:', { eventCategory: eventCategory, eventAction: eventAction });
                if (isDefined(window.dataLayer)) {
                    // На сайте установлен GTM
                    window.dataLayer.push({ event: eventCategory + "." + eventAction });
                } else if (isDefined(window.ga)) {
                    window.ga('send', 'event', { eventCategory: eventCategory, eventAction: eventAction });
                }
            },
            setYaEvent: function setYaEvent(name) {
                var once = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

                if (once) {
                    if (ymEvents.indexOf(name) !== -1) {
                        return;
                    }
                    ymEvents.push(name);
                }
                if (app.debug || typeof window.yaCounter20615926 === 'undefined') {
                    console.log('setYaEvent: ', name, params);
                } else {
                    window.yaCounter20615926.reachGoal(name, params);
                }
            },
            stat: function stat(type, params) {
                // если тут ставить window.top.location.href, то падает вебвизор из-за CORS
                var data = {
                    ukey: app.ukey,
                    cityId: app.city && app.city.id ? app.city.id : null,
                    realCityId: app.realCity && app.realCity.id ? app.realCity.id : null,
                    srcId: app.src_id,
                    type: type,
                    href: window.location.href,
                    isFrame: window != window.top,
                    params: params
                };
                if (!app.isProduction) {
                    console.log('stat:', type, data);
                    console.info('stat is disabled for DEV mode');
                    return false;
                }

                if (rt.isOnline()) {
                    rt.go('stat.save', data);
                } else {
                    statLog.push(data);
                    rt.afterLogin['saveStatLog'] = function () {
                        if (statLog.length) {
                            rt.go('stat.save', statLog);
                            statLog = [];
                        }
                        delete rt.afterLogin['saveStatLog'];
                    };
                }
            },
            statOnce: function statOnce(type, params) {
                if (statEvents.indexOf(type) !== -1) {
                    return false;
                }

                statEvents.push(type);
                window.tracking.stat(type, params);

                return true;
            },
            callTrackingRefresh: function callTrackingRefresh() {
                if (window.roistatCallTrackingRefresh) {
                    window.roistatCallTrackingRefresh();
                }
                window.tracking.refreshWhatsAppLink();
                window.tracking.setRoistatVisitDeviceId();
            },
            /**
             * Сохраняем параметры визита только через этот метод, чтобы не перезаписывать используемые параметры
             * Так как собственные переменные давать нельзя,
             * то используем roistat_param2, roistat_param3, roistat_param4
             */
            setRoistatVisitDeviceId: function setRoistatVisitDeviceId() {
                console.log('setRoistatVisitDeviceId', window.roistat);
                if (window.roistat) {
                    var params = {};
                    if (window.ymVisitParams && window.ymVisitParams.pageType) {
                        params.roistat_param1 = window.ymVisitParams.pageType;
                    }
                    if (window.amplitude && typeof window.amplitude.getDeviceId() !== 'undefined') {
                        params.roistat_param2 = window.amplitude.getDeviceId();
                    }
                    if (window.userActivity) {
                        params.roistat_param3 = window.userActivity.getVUid();
                    }
                    // Нужен для отслеживания оффлайн конверсий ga4
                    var urlParams = new URLSearchParams(window.location.search);
                    var googleClickId = urlParams.get('gclid');
                    if (googleClickId) {
                        params.roistat_param4 = googleClickId;
                    }
                    console.log('roistat set params', params);
                    window.roistat.setRoistatParams(params);
                }
            },

            refreshWhatsAppLink: function refreshWhatsAppLink() {
                if ('roistatGetCookie' in window) {
                    var message = 'Здравствуйте, мой номер заявки: {roistat_visit} \n\n Меня интересуют туры в';
                    var text = message.replace(/{roistat_visit}/g, window.roistatGetCookie('roistat_visit'));
                    text = encodeURI(text);
                    var linkElements = document.querySelectorAll('[href*="//wa.me/"]');
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = linkElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var element = _step.value;

                            var url = element.href;
                            var param = 'text';
                            var value = text;
                            var explodedUrl = url.split('?');
                            var baseUrl = explodedUrl[0] || '';
                            var query = '?' + (explodedUrl[1] || '');
                            var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
                            var queryWithoutParameter = query.replace(regex, "$1").replace(/&$/, '');
                            element.href = baseUrl + (queryWithoutParameter.length > 2 ? queryWithoutParameter + '&' : '?') + (value ? param + "=" + value : '');
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            formConversion: formConversion
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        $(document).one('yacounter20615926inited', function () {
            /**
             * @var {[{key: string, variation: string}]}
             */
            if (window.ymVisitParamExperiments.length) {
                var experiments = {};
                var experiment = void 0;
                for (var i = 0; i < ymVisitParamExperiments.length; i++) {
                    experiment = ymVisitParamExperiments[i];
                    experiments['experiment_' + experiment.id] = experiment.variation;
                }
                /**
                 * @var {{}}
                 */
                window.yaCounter20615926.params({
                    experiments: experiments
                });
                window.ymVisitParamExperiments = [];
            }
        });

        $(document).one('creditSubmitSuccess', function (event, data) {
            window.tracking.setYaEvent('creditRequest.submit');
            window.tracking.setGAEvent('creditRequest', 'submit');

            var bankId = Number(data.bankId);
            if (bankId === 2) {
                // TMP. Kaspi. На время акции Каспи туризм
                window.tracking.setYaEvent('creditRequest.submitKaspi');
                window.tracking.setGAEvent('creditRequest', 'submitKaspi');
            }
        });

        (function () {
            if (window.roistat !== undefined) {
                handler();
            } else {
                var pastCallback = typeof window.onRoistatAllModulesLoaded === "function" ? window.onRoistatAllModulesLoaded : null;
                window.onRoistatAllModulesLoaded = function () {
                    if (pastCallback !== null) {
                        pastCallback();
                    }
                    // обязательно тут, чтобы подменились ватсап текста
                    window.tracking.callTrackingRefresh();

                    handler();
                };
            }

            function handler() {
                function init() {
                    appendMessageToLinks();

                    var delays = [1000, 5000, 15000];
                    setTimeout(function func(i) {
                        if (i === undefined) {
                            i = 0;
                        }
                        appendMessageToLinks();
                        i++;
                        if (typeof delays[i] !== 'undefined') {
                            setTimeout(func, delays[i], i);
                        }
                    }, delays[0]);
                }

                function appendMessageToLinks() {
                    window.tracking.refreshWhatsAppLink();
                }
                if (document.readyState === 'loading') {
                    document.addEventListener('DOMContentLoaded', init);
                } else {
                    init();
                }
            }
        })();
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var MAP_TYPE_GOOGLE = 'google';
        var MAP_TYPE_YANDEX = 'yandex';
        var WRAPPER_CSS_CLASS = 'js-map-instance-wrapper';

        var GMapLoader = function () {
            function GMapLoader() {
                _classCallCheck(this, GMapLoader);

                if (typeof window.gmapLoader !== 'undefined') {
                    throw new Error('only one instance of GMapLoader');
                }
                this.wrapperCssClass = WRAPPER_CSS_CLASS;
                this.type = MAP_TYPE_GOOGLE;

                this.isLoadStarted = false;
                this.isLoaded = typeof window.google !== 'undefined' && window.google.hasOwnProperty('maps');
                this.callbacks = [];

                this.list = {};
                this.mapIndex = 0;
            }

            /**
             * @param {BaseMap} mapInstance
             * @param $wrapper
             */


            _createClass(GMapLoader, [{
                key: "addToStorage",
                value: function addToStorage(mapInstance, $wrapper) {
                    var storageKey = 'gMap' + this.mapIndex;
                    this.list[storageKey] = {
                        instance: mapInstance,
                        $wrapper: $wrapper
                    };

                    $wrapper.data('map-key', storageKey).data('map-type', this.type).addClass(this.wrapperCssClass);

                    this.mapIndex++;
                }
            }, {
                key: "load",
                value: function load(callback) {
                    if (typeof callback !== 'function') {
                        console.error('callback must be a function');
                    }

                    this.callbacks.push(callback);
                    if (this.isLoaded) {
                        this.onLoad();
                    } else {
                        if (!this.isLoadStarted) {
                            this.isLoadStarted = true;
                            var apiKey = app.maps.keys.google;
                            var apiUrl = "https://maps.googleapis.com/maps/api/js?v=3&key=" + apiKey + "&callback=gmapLoader.onLoad";
                            $.getScript(apiUrl, function () {});
                        }
                    }
                }
            }, {
                key: "onLoad",
                value: function onLoad() {
                    this.isLoaded = true;
                    if (this.callbacks.length > 0) {
                        for (var i = 0; i < this.callbacks.length; i++) {
                            this.callbacks[i]();
                        }
                    }

                    this.callbacks = [];
                }
            }, {
                key: "destroy",
                value: function destroy(key) {
                    if (!this.list.hasOwnProperty(key)) {
                        console.warn('unknown map key');
                    }
                    var item = this.list[key];
                    item.instance.destroy();
                    item.$wrapper.removeClass(this.wrapperCssClass);

                    delete this.list[key];
                }
            }]);

            return GMapLoader;
        }();

        //
        //  ============ ============  ============ ============ ============ YANDEX START
        //
        /**
         * Загрузить все необходимое для карт
         * @type {string}
         */


        var YANDEX_API_MAP = 'map';
        /**
         * Загрузить все необходимое для геолокации
         * @type {string}
         */
        var YANDEX_API_GEOLOCATION = 'geolocation';

        var ymapsApiLoader = {
            isLoadStarted: false,
            isLoaded: function isLoaded() {
                return typeof window.ymaps !== 'undefined';
            },
            load: function load() {
                if (ymapsApiLoader.isLoaded()) {
                    ymapsApiLoader.onLoad();
                } else {
                    if (!ymapsApiLoader.isLoadStarted) {
                        ymapsApiLoader.isLoadStarted = true;
                        var apiUrl = ymapsApiLoader.getUrl();
                        $.getScript(apiUrl);
                    }
                }
            },
            getUrl: function getUrl() {
                var apiKey = "&apikey=" + app.maps.keys.yandex;
                // При mode=debug грузит все API сразу, не смотря на package
                var mode = 0 && app.debug ? '&mode=debug' : '';

                // По умолчанию ничего не загружается
                var packages = '';
                var loadPackage = "&load=" + packages;
                var onLoadCallback = 'onYaMapApiLoad';
                // Последня версия 2.1.77 грузит ~700+Кб .js.gz, в не зависимости от package.
                // Зафиксировал 2.1.76, тут еще работает отложенная загрузка.
                return "https://api-maps.yandex.ru/2.1.76/?lang=ru_RU&onload=" + onLoadCallback + loadPackage + mode + apiKey;
            },
            onLoad: function onLoad() {
                window.ymapLoader.onApiLoad();
                window.ymapGeolocationLoader.onApiLoad();
            }
        };
        window.onYaMapApiLoad = ymapsApiLoader.onLoad;

        var BaseYMapLoader = function () {
            /**
             * @param {string} packageType
             */
            function BaseYMapLoader(packageType) {
                _classCallCheck(this, BaseYMapLoader);

                /**
                 * @type {string}
                 */
                this.packageType = packageType;

                /**
                 * @type {Array}
                 */
                this.callbacks = [];

                /**
                 * @type {boolean}
                 */
                this.isLoadStarted = false;

                /**
                 * @type {boolean}
                 */
                this.isLoaded = false;
                switch (this.packageType) {
                    case YANDEX_API_GEOLOCATION:
                        this.isLoaded = window.ymaps && window.ymaps.geolocation;
                        break;
                    case YANDEX_API_MAP:
                    default:
                        this.isLoaded = window.ymaps && window.ymaps.Map;
                        break;
                }
            }

            _createClass(BaseYMapLoader, [{
                key: "onApiLoad",
                value: function onApiLoad() {}

                /**
                 * @param {Function} callback
                 */

            }, {
                key: "load",
                value: function load(callback) {
                    this.callbacks.push(callback);
                    if (this.isLoaded) {
                        this.onLoad();
                    } else {
                        if (!this.isLoadStarted) {
                            this.isLoadStarted = true;
                            ymapsApiLoader.load();
                        }
                    }
                }
            }, {
                key: "onLoad",
                value: function onLoad() {
                    this.isLoaded = true;
                    if (this.callbacks.length > 0) {
                        for (var i = 0; i < this.callbacks.length; i++) {
                            this.callbacks[i]();
                        }
                    }

                    this.callbacks = [];
                }
            }]);

            return BaseYMapLoader;
        }();

        // -------------> YANDEX GEOLOCATION <-------------


        var YMapGeolocationLoader = function (_BaseYMapLoader) {
            _inherits(YMapGeolocationLoader, _BaseYMapLoader);

            function YMapGeolocationLoader() {
                _classCallCheck(this, YMapGeolocationLoader);

                return _possibleConstructorReturn(this, (YMapGeolocationLoader.__proto__ || Object.getPrototypeOf(YMapGeolocationLoader)).call(this, YANDEX_API_GEOLOCATION));
            }

            _createClass(YMapGeolocationLoader, [{
                key: "onApiLoad",
                value: function onApiLoad() {
                    var _this2 = this;

                    var isWaitingGeolocation = !!this.callbacks.length;
                    if (!isWaitingGeolocation) {
                        return false;
                    }
                    if (!window.ymaps.geolocation) {
                        ymaps.ready({
                            require: ['geolocation'],
                            successCallback: function successCallback(ym) {
                                _this2.onLoad();
                            }
                        });
                    } else {
                        this.onLoad();
                    }
                }
            }]);

            return YMapGeolocationLoader;
        }(BaseYMapLoader);
        // -------------> YANDEX GEOLOCATION END <-------------

        // -------------> YANDEX MAP <-------------


        var YMapLoader = function (_BaseYMapLoader2) {
            _inherits(YMapLoader, _BaseYMapLoader2);

            function YMapLoader() {
                _classCallCheck(this, YMapLoader);

                var _this3 = _possibleConstructorReturn(this, (YMapLoader.__proto__ || Object.getPrototypeOf(YMapLoader)).call(this, YANDEX_API_MAP));

                if (typeof window.ymapLoader !== 'undefined') {
                    throw new Error('only one instance of YMapLoader');
                }
                _this3.wrapperCssClass = WRAPPER_CSS_CLASS;
                _this3.type = MAP_TYPE_YANDEX;

                _this3.list = {};
                _this3.mapIndex = 0;
                return _this3;
            }

            _createClass(YMapLoader, [{
                key: "onApiLoad",
                value: function onApiLoad() {
                    var _this4 = this;

                    var isWaitingMap = !!this.callbacks.length;
                    if (!isWaitingMap) {
                        return false;
                    }

                    if (!ymaps.Map) {
                        // Пример использования расширенного синтаксиса функции ready.
                        ymaps.ready({
                            // successCallback будет вызван, когда загрузятся API и модуль "myModule1".
                            require: ['Map', 'Placemark', 'data.Manager', 'util.bounds', 'control.ZoomControl', 'geoObject.addon.balloon', 'geoObject.addon.hint'],
                            successCallback: function successCallback(ym) {
                                _this4.onLoad();
                            }
                        });
                    } else {
                        this.onLoad();
                    }
                }
            }, {
                key: "destroy",
                value: function destroy(key) {
                    if (!this.list.hasOwnProperty(key)) {
                        console.warn('unknown map key');
                    }
                    var item = this.list[key];
                    item.instance.destroy();
                    item.$wrapper.removeClass(this.wrapperCssClass);

                    delete this.list[key];
                }

                /**
                 * @param {BaseMap|OfficeMap|OfficeSchemeMap} mapInstance
                 *      (OfficeSchemeMap - старая карта)
                 * @param $wrapper - сюда будет добавлен идентификтор карты, для последующего удаления
                 */

            }, {
                key: "addToStorage",
                value: function addToStorage(mapInstance, $wrapper) {
                    var storageKey = 'yMap' + this.mapIndex;
                    this.list[storageKey] = {
                        instance: mapInstance,
                        $wrapper: $wrapper
                    };

                    $wrapper.data('map-key', storageKey).data('map-type', this.type).addClass(this.wrapperCssClass);

                    this.mapIndex++;
                }
            }]);

            return YMapLoader;
        }(BaseYMapLoader);
        // -------------> YANDEX MAP END <-------------

        //
        //  ============ ============  ============ ============ ============ YANDEX END
        //

        /*
        class OsmMapLoader {
            constructor() {
                if (typeof window.osmMapLoader !== 'undefined') {
                    throw new Error('only one instance of OsmMapLoader');
                }
        
                this.wrapperCssClass = WRAPPER_CSS_CLASS;
                this.type = MAP_TYPE_YANDEX;
        
                this.isLoadStarted = false;
                this.isLoaded = typeof(window.osm) !== 'undefined' && window.osm.hasOwnProperty('mapboxgl');
                this.callbacks = [];
        
                this.list = {};
                this.mapIndex = 0;
        
                this.fullyLoadTimeout = null;
                this.expectedApiVersion = '0.51.0';
                this.accessToken = window.maps.;
            }
        
            addToStorage(mapInstance, $wrapper) {
                const storageKey = 'osmMap' + this.mapIndex;
                this.list[storageKey] = {
                    instance: mapInstance,
                    $wrapper: $wrapper,
                };
        
                $wrapper
                    .data('map-key', storageKey)
                    .data('map-type', this.type)
                    .addClass(this.wrapperCssClass);
        
                this.mapIndex++;
            }
        
            load(callback) {
                if (typeof callback !== 'function') {
                    console.error('callback must be a function');
                }
                this.callbacks.push(callback);
                if (this.isLoaded) {
                    this.onLoad();
                } else {
                    if (!this.isLoadStarted) {
                        this.isLoadStarted = true;
                        const nodeScript = document.createElement('script');
                        nodeScript.src = `https://map.myht.kz/assets/map.js`;
                        nodeScript.type = 'text/javascript';
                        nodeScript.onload = function () {
                            window.osmMapLoader._onBaseScriptLoad();
                        };
                        nodeScript.onerror = (err) => {
                            console.error('Не удалось загрузить OSM');
                        };
                        document.getElementsByTagName('head')[0].appendChild(nodeScript);
                    }
                }
            }
        
            _getApiUrl() {
                return `https://map.myht.kz/assets/map.js`;
            }
        
            _onBaseScriptLoad() {
                if (!this.loadTryCount) this.loadTryCount = 0;
                this.loadTryCount++;
                if (typeof window.osm !== 'undefined' && window.osm.mapboxgl) {
                    console.log('Osm maps loaded');
                    this.isLoaded = true;
                    this._prototypeMarker();
                    this.onLoad();
                } else {
        
                    // check osm map api load status once on N ms
                    const retryInMs = 100;
                    // Max load waiting time. After fail message
                    const maxWaitMs = 1500;
        
                    if (this.fullyLoadTimeout) {
                        clearTimeout(this.fullyLoadTimeout);
                    }
                    if (this.loadTryCount > maxWaitMs/retryInMs) {
                        console.error('unable download osm map api');
                        return false;
                    }
                    // check once on 100ms mapbox api load status
                    this.fullyLoadTimeout = setTimeout(() => {
                        this._onBaseScriptLoad();
                    }, retryInMs);
                }
            }
        
            onLoad() {
                if (this.callbacks.length > 0) {
                    for (let i = 0; i < this.callbacks.length; i++) {
                        this.callbacks[i]();
                    }
                }
        
                this.callbacks = [];
            }
        
            _prototypeMarker() {
                osm.mapboxgl.Marker.prototype.setVisible = function(visible) {
                    const iconElement = this.getElement();
                    if (!iconElement) {
                        console.warn('setVisible is unavailable for osm Marker');
                        return;
                    }
                    if (visible) {
                        iconElement.classList.remove('hidden');
                    } else {
                        iconElement.classList.add('hidden');
                    }
                    this.visible = visible;
                };
                osm.mapboxgl.Marker.prototype.getVisible = function() {
                    return this.visible;
                };
                osm.mapboxgl.Marker.prototype.get = function(key) {
                    return this.customData && this.customData[key] ? this.customData[key] : null;
                };
                osm.mapboxgl.Marker.prototype.set = function(key, value) {
                    if (typeof this.customData === 'undefined') {
                        this.customData = {};
                    }
                    this.customData[key] = value;
                };
            }
        }
        */

        window.removeAllMapsInElement = function ($parent) {
            $parent.find('.' + WRAPPER_CSS_CLASS).each(function () {
                var $mapWrapper = $(this);
                var storageKey = $mapWrapper.data('map-key');
                var mapType = $mapWrapper.data('map-type');
                switch (mapType) {
                    case MAP_TYPE_YANDEX:
                        ymapLoader.destroy(storageKey);
                        break;
                }
            });
        };

        // window.osmMapLoader = new OsmMapLoader();
        window.gmapLoader = new GMapLoader();
        window.ymapLoader = new YMapLoader();
        window.ymapGeolocationLoader = new YMapGeolocationLoader();
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var callbackRequestFunc = require('../../../include/_js/callback/callback-request');
        var CallbackParams = require('../../../include/_js/callback/CallbackParams');

        var DEFAULT_WORK_START_HOUR = 10;
        var DEFAULT_WORK_END_HOUR = 19;
        var SATURDAY_WORK_END_HOUR = 15;

        /**
         * @param date
         * @return {object}
         * @private
         */
        function getWorkingTimeBounds(date) {
            var dayOfWeek = date.getDay();
            var bounds = {
                from: null,
                to: null
            };

            if (dayOfWeek === 0) {
                // в вс не работаем
                return bounds;
            }

            bounds.from = DEFAULT_WORK_START_HOUR;
            // день недели
            switch (dayOfWeek) {
                case 6:
                    // в сб до 3 можно подать заявку
                    bounds.to = SATURDAY_WORK_END_HOUR;
                    break;
                default:
                    bounds.to = DEFAULT_WORK_END_HOUR;
                    break;
            }

            return bounds;
        }

        window.callRequest = {
            Params: CallbackParams,
            // errorFields: callbackParams.errorFields,
            /**
             * @param {CallbackParams} params
             * @param callback
             */
            create: callbackRequestFunc,
            isWorkingTimeNow: function isWorkingTimeNow() {
                var now = new Date();
                var currentHour = now.getHours();
                // var sundayDate = '2018-4-8';
                // var d = new Date(sundayDate);
                // d.setHours(8);

                var timeBounds = getWorkingTimeBounds(now);
                if (timeBounds.from === null) {
                    return false;
                }

                var isNotWorkingMorning = currentHour < timeBounds.from;
                var isNotWorkingEvening = currentHour >= timeBounds.to;

                return !(isNotWorkingMorning || isNotWorkingEvening);
            }
        };

        window.loadGoogleCaptcha = function () {
            return new Promise(function (resolve, reject) {
                if (typeof grecaptcha !== 'undefined') {
                    resolve();
                    return;
                }

                var script = document.createElement('script');
                script.src = "https://www.google.com/recaptcha/api.js?render=" + window.app.googleCaptchaSiteKey;
                script.async = true;
                script.defer = true;

                script.onload = function () {
                    var waitForGrecaptcha = setInterval(function () {
                        if (typeof grecaptcha !== 'undefined' && grecaptcha.ready) {
                            clearInterval(waitForGrecaptcha);
                            resolve();
                        }
                    }, 100);
                };

                script.onerror = function (error) {
                    return reject(new Error('Failed to load reCAPTCHA'));
                };

                document.head.appendChild(script);
            });
        };
    }, { "../../../include/_js/callback/CallbackParams": 2, "../../../include/_js/callback/callback-request": 3 }], 2: [function (require, module, exports) {
        var FIELD_PHONE = 'phone';
        var FIELD_DATE_TIME = 'dateTime';

        var CallbackParams = function () {
            function CallbackParams(params) {
                _classCallCheck(this, CallbackParams);

                this.srcId = app.src_id ? app.src_id : null;
                this.vUid = app.v_uid ? app.v_uid : '';

                this.cityId = parseInt(params.cityId, 10);
                this.formTypeId = parseInt(params.formTypeId, 10);
                this.phone = params.phone.trim();
                this.countryCode = params.hasOwnProperty('phoneCountryCode') ? params.phoneCountryCode.trim() : '';
                this.isChooseCallTime = params.hasOwnProperty('isChooseCallTime') ? parseInt(params.isChooseCallTime, 10) : 0;

                this.callDate = '';
                this.callTime = '';
                if (this.isChooseCallTime) {
                    this.callDate = params.callDate;
                    this.callTime = params.callTime;
                }

                /**
                 * Отдельная "цель" на успешный заказ колебка в YM
                 * @type {string}
                 */
                this.ymConversionEvent = '';
                if (params.ymConversionEvent) {
                    this.setYMConversionEvent(params.ymConversionEvent);
                }
                /**
                 * Отдельная цель на успешный заказ колбека в GA
                 * @deprecated - c GTM не работает. Нужно другое решение
                 * @type {{eventCategory: string, eventAction: string}|null}
                 */
                this.gaConversionEvent = null;
                if (params.hasOwnProperty('gaConversionEventCategory') && params.hasOwnProperty('gaConversionEventAction')) {
                    this.setGAConversionEvent(params.gaConversionEventCategory, params.gaConversionEventAction);
                }

                this.errorList = {};
                this.errorList[FIELD_PHONE] = {
                    error: false,
                    message: ''
                };
                this.errorList[FIELD_DATE_TIME] = {
                    error: false,
                    message: ''
                };
            }

            _createClass(CallbackParams, [{
                key: "setYMConversionEvent",
                value: function setYMConversionEvent(eventKey) {
                    this.ymConversionEvent = eventKey;
                }
            }, {
                key: "setGAConversionEvent",
                value: function setGAConversionEvent(eventCategory, eventAction) {
                    if (!eventCategory || !eventCategory) {
                        return false;
                    }
                    this.gaConversionEvent = {
                        category: eventCategory,
                        action: eventAction
                    };
                }
            }, {
                key: "validate",
                value: function validate() {
                    var isValid = true;
                    if (this.isChooseCallTime) {
                        if (this.callDate === '' || this.callTime === '') {
                            isValid = false;
                            this._addError(FIELD_DATE_TIME, 'Выберите время звонка');
                        } else if (parseInt(this.callTime, 10) === -1) {
                            isValid = false;
                            this._addError(FIELD_DATE_TIME, 'Выберите время звонка');
                        }
                    }

                    if (this.phone.length !== 10) {
                        isValid = false;
                        this._addError(FIELD_PHONE, 'Проверьте номер телефона');
                    }

                    return isValid;
                }

                /**
                 *
                 * @param formFields - e.g. $form.serializeArray()
                 * @return {CallbackParams}
                 */

            }, {
                key: "haveError",


                /**
                 * @param {string} field
                 * @return {boolean}
                 */
                value: function haveError(field) {
                    return this.errorList[field].error;
                }
            }, {
                key: "_addError",


                // get errors() {
                //     return this.errorList;
                // }

                value: function _addError(field, message) {
                    if (!this.errorList.hasOwnProperty(field)) {
                        return false;
                    }

                    this.errorList[field].error = true;
                    this.errorList[field].message = message;
                }
            }, {
                key: "errorFields",
                get: function get() {
                    return {
                        PHONE: FIELD_PHONE,
                        DATETIME: FIELD_DATE_TIME
                    };
                }

                /**
                 * Первое сообщение об ошибке
                 * @return {{field: string, message: string}}
                 */

            }, {
                key: "error",
                get: function get() {
                    var data = { field: '', message: '' };
                    if (this.errorList.phone.error) {
                        data.field = FIELD_PHONE;
                        data.message = this.errorList.phone.message;
                    } else if (this.errorList.dateTime.error) {
                        data.field = FIELD_DATE_TIME;
                        data.message = this.errorList.dateTime.message;
                    }

                    return data;
                }
            }], [{
                key: "loadForm",
                value: function loadForm(formFields) {
                    var params = {};
                    for (var i in formFields) {
                        var field = formFields[i];
                        params[field.name] = field.value;
                    }

                    return new CallbackParams(params);
                }
            }]);

            return CallbackParams;
        }();

        module.exports = CallbackParams;
        // module.exports = {
        //     Params: CallbackParams,
        //     errorFields: {
        //         PHONE: FIELD_PHONE,
        //         DATETIME: FIELD_DATE_TIME,
        //     },
        // };
    }, {}], 3: [function (require, module, exports) {
        var ERROR_NOT_WORKING_TIME = 'not_working_time';
        var ERROR_NON_CORRECT_DATA = 'non_correct_data';
        var ERROR_EXIST = 'callback exist timeout';

        /**
         * @param {CallbackParams} params
         * @param {Function} callback
         */
        module.exports = function (params, callback) {
            var data = {
                success: false,
                title: '',
                message: '',
                allowRepeat: false
            };

            if (!params.validate()) {
                callback(data);
                return false;
            }

            var requestParams = {
                srcId: params.srcId,
                vUid: params.vUid,

                cityId: params.cityId,
                formTypeId: params.formTypeId,
                phone: params.phone,
                countryCode: params.countryCode,
                isChooseCallTime: params.isChooseCallTime,
                recaptchaToken: params.recaptchaToken
            };
            if (requestParams.isChooseCallTime) {
                requestParams.callDate = params.callDate;
                requestParams.callTime = params.callTime;
            }

            $.post(app.urls.addCallback, requestParams, function (responseData) {
                var translates = responseData.translates;
                if (responseData.error) {
                    data.title = translates.error;
                    data.allowRepeat = true;
                    switch (responseData.error_type) {
                        case ERROR_NON_CORRECT_DATA:
                            data.message = translates.invalidData;
                            break;
                        // @deprecated
                        // case ERROR_NOT_WORKING_TIME:
                        //     data.message = 'К сожалению, рабочий день окончен';
                        //     break;
                        case ERROR_EXIST:
                            data.title = translates.callBackSoon;
                            data.allowRepeat = false;
                            break;
                        default:
                            data.message = translates.errorOccurred;
                            break;
                    }
                } else {
                    data.success = true;
                    if (app.isMobile) {
                        data.title = translates.applicationReceived;
                    } else {
                        data.title = translates.thankYouForApplication;
                        if (requestParams.isChooseCallTime) {
                            data.message = translates.callBackAtSelectedTime;
                        } else {
                            data.message = translates.callYouSoon;
                        }
                    }

                    /**
                     * @deprecated
                     * @see window.tracking.formConversion.markCallback()
                     */
                    window.tracking.setYaEvent('callback.createSuccess');
                    window.tracking.setGAEvent('siteCallback', 'create');
                    // TODO: не работает после переезда на GTM
                    if (params.ymConversionEvent) {
                        window.tracking.setYaEvent(params.ymConversionEvent);
                    }
                    if (params.gaConversionEvent) {
                        var gaEvent = params.gaConversionEvent;
                        window.tracking.setGAEvent(gaEvent.category, gaEvent.action);
                    }
                }
                callback(data);
            }, 'json');
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        window.userActivity = {
            getVUid: function getVUid() {
                return app.v_uid;
            },
            generateVUid: function generateVUid() {
                if (!app.v_uid) {
                    var history = userActivity.getUserHistory();
                    rt.go('app.getVUid', { history: history, site: 1 }, function (vUid) {
                        userActivity.setVUid(vUid);
                    });
                } else {
                    userActivity.setVUid(app.v_uid); // prolong
                }
            },
            /**
             * @param {string} vUid
             */
            setVUid: function setVUid(vUid) {
                app.v_uid = vUid;
                window.utils.cookies.set('clbk_v_uid', vUid, {
                    expires: 730 * 24 * 60 * 60,
                    path: '/'
                });
            },
            getUserHistory: function getUserHistory() {
                if (!window.utils.isLocalStorageSupported) {
                    return {};
                }
                // парсим значение в localStorage
                var historyValue = window.localStorage.getItem('userHistory');
                var historyObj = [];
                if (historyValue != null) {
                    historyObj = JSON.parse(historyValue);
                }

                try {
                    // выкидываем слишком старые записи
                    // храним последние 300 действий
                    return historyObj.slice(0, 299);
                } catch (e) {
                    // если historyObj не массив, а объект, обнуляем историю действий
                    historyObj = [];
                    window.localStorage.setItem('userHistory', JSON.stringify(historyObj));

                    return historyObj;
                }
            },
            /**
             * @param data
             * @return {boolean}
             */
            updateUserHistory: function updateUserHistory(data) {
                var item = {
                    time: new Date().getTime(),
                    type: data.type,
                    url: data.hasOwnProperty('url') ? data.url : '',
                    desc: data.hasOwnProperty('desc') ? data.desc : '',
                    ip: (typeof app === "undefined" ? "undefined" : _typeof(app)) === 'object' && app.ip ? app.ip : '',
                    item_id: data.hasOwnProperty('item_id') ? data.item_id : null
                };

                // если v_uid уже есть, то сохраняем действия
                if (app.v_uid) {
                    item.v_uid = app.v_uid;
                    rt.go('app.save_user_activity', item);
                } else {
                    if (!window.utils.isLocalStorageSupported) {
                        return false;
                    }
                    var historyObj = userActivity.getUserHistory();
                    // добавляем новый элемент
                    var newHistory = [item];
                    newHistory = newHistory.concat(historyObj);
                    // пишем в localStorage
                    window.localStorage.setItem('userHistory', JSON.stringify(newHistory));
                }

                return true;
            },
            setUserAction: function setUserAction(url, title) {
                userActivity.updateUserHistory({
                    type: 'page',
                    url: url,
                    desc: title
                });
                userActivity.generateVUid();
            },
            // function call may be registered from backend
            saveVisit: function saveVisit() {
                userActivity.setUserAction(location.href, document.title);
            }
        };
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var widgetInstance = null;
        var _isLoaded = false;
        window.textBackWidgetSDK = {
            isLoaded: function isLoaded() {
                return _isLoaded;
            },
            onLoad: function onLoad() {
                _isLoaded = true;
                textBackWidgetSDK.isLoaded = true;
                var config = {
                    widgetId: 'b38e8d86-7bf2-2eb5-2fa6-016f9d4720bf'
                };

                TextBack.SDK.initWidget(config).then(function (widget) {
                    widgetInstance = widget;
                    // widgetInstance.getEnabledChannels();
                    $('.page-bottom-buttons .whatsapp-button').removeClass('hidden');
                });
            },
            subscribeWhatsapp: function subscribeWhatsapp() {
                if (!widgetInstance) {
                    return false;
                }

                widgetInstance.subscribe('whatsapp');

                return true;
            }
        };
        // SDK грузится async. Если загрузится раньше
        if (window.TextBack) {
            textBackWidgetSDK.onLoad();
        }
    }, {}] }, {}, [1]);

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var defaultWatchEvents = app.watchEvents || [];

        /**
         * События, на которые добавлена подписка в dom, и их состояние (сработали или нет)
         * @type {{}}
         */
        var domListenersList = {};
        /**
         * События, которые ждут срабатывания
         * @type {Array}
         */
        var listenersList = [];
        /**
         * Подписка на одно или несколько событий одновременно
         * e.g. addScriptReadyListenerOnce(['searchScriptLoaded', 'searchFormInstanceCreated', 'hotTableToursViewInstanceReady'], () => {
         * // do something when all events fired });
         * @param {Array} eventsList
         * @param {Function} callback
         */
        window.addScriptReadyListenerOnce = function (eventsList, callback) {
            listenersList.push({
                dependencies: eventsList,
                callback: callback
            });
            addScriptReadyDomListeners(eventsList);
            // если на момент подписки событие произошло
            dispatchScriptReadyEvents();
        };

        /**
         * @param {string} eventType
         */
        window.setScriptReadyEventOnce = function (eventType) {
            if (!domListenersList.hasOwnProperty(eventType)) {
                // Если никто не подписался на эти события заранее, делаем фейковую подписку,
                // чтобы не пропустить event
                addScriptReadyDomListeners([eventType]);
            }
            $(window).trigger(eventType);
        };

        function dispatchScriptReadyEvents() {
            var notReadyListeners = [];
            for (var i in listenersList) {
                var listener = listenersList[i];
                var ready = true;
                for (var j = 0; j < listener.dependencies.length; j++) {
                    var eventType = listener.dependencies[j];
                    if (!domListenersList.hasOwnProperty(eventType) || domListenersList[eventType] !== true) {
                        ready = false;
                    }
                }
                if (ready) {
                    // все готово
                    listener.callback();
                } else {
                    // откладываем
                    notReadyListeners.push(listener);
                }
            }
            listenersList = notReadyListeners;
        }

        /**
         * @param {Array} eventsList
         */
        function addScriptReadyDomListeners(eventsList) {
            var eventType = void 0;
            for (var i = 0; i < eventsList.length; i++) {
                eventType = eventsList[i];
                if (!domListenersList.hasOwnProperty(eventType)) {
                    domListenersList[eventType] = false;
                    $(window).one(eventType, function (event) {
                        domListenersList[event.type] = true;
                        dispatchScriptReadyEvents();
                    });
                }
            }
        }
        // подписываемся на события при загрузке, чтобы не пропустить
        addScriptReadyDomListeners(defaultWatchEvents);
    }, {}] }, {}, [1]);